const accountManagementStrings = {
  login: {
    formUsernameFieldPlaceholder: 'Username',
    formPasswordFieldPlaceholder: 'Password',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    formBtnText: 'Login with Azure AD',
  },
};

export default accountManagementStrings;
